import { render, staticRenderFns } from "./back-urgentorder-list.vue?vue&type=template&id=809f1b36&"
import script from "./back-urgentorder-list.vue?vue&type=script&lang=ts&"
export * from "./back-urgentorder-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports